import { getCurrencySymbol } from '@helpers/utils/currency-helper';
import { PriceDropZoneResponse, RecommendationsPriceResponse, SimilarSoldProduct } from '../domain/SellerPrice';
import { PriceDropZoneDTO, RecommendationsPriceDTO, SimilarSoldProductDTO } from '../dto/SellerPriceDTO';

export const mapSellerPriceFromDTO = (dto: PriceDropZoneDTO): PriceDropZoneResponse => {
  return {
    priceZone: {
      id: dto.priceZone.id,
      showApplyRecommendedPrice: dto.priceZone.showApplyRecommendedPrice,
    },
  };
};

const mapSimilarSoldProductFromDTO = (dto: SimilarSoldProductDTO): SimilarSoldProduct => {
  return {
    productId: dto.productId,
    picture: dto.picture,
    brand: dto.brand,
    soldTimestampUTC: dto.soldTimestampUTC,
    title: dto.title,
    price: dto.price,
    status: dto.status,
  };
};

export const mapRecommendationsPriceFromDTO = (dto: RecommendationsPriceDTO): RecommendationsPriceResponse => {
  return {
    id: dto.id,
    brand: dto.brand,
    name: dto.name,
    originalPrice: dto.originalPrice,
    priceDropped: dto.priceDropped,
    currencySymbol: getCurrencySymbol(dto.originalPrice.currency),
    pictures: dto.pictures,
    daysOnline: dto.daysOnline,
    pricingBreakdown: dto.pricingBreakdown,
    recommendedPrice: dto.recommendedPrice,
    similarProducts: dto.similarProducts?.map(mapSimilarSoldProductFromDTO) || [],
    path: '', // to update when the field is added to RecommendationsPriceResponse endpoint
  };
};
